import { CommandBar, ITooltipHostStyles, Pivot, Text, mergeStyles } from '@fluentui/react';

export const StyledCommandBar = styled(CommandBar)`
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-left: -32px;
  column-gap: 32px;
`;

export const BoxComponent = styled.div`
  background: #fafafa; //grey
  border: 1px solid #000000;
`;

export const TableComponent = styled.table`
  padding-left: 3%;
  padding-right: 3%;
  padding-bottom: 3%;
`;

export const tooltipHostStyles: Partial<ITooltipHostStyles> = { root: { display: 'inline-block' } };

export const RequestStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding-top: 24px; // Wizard Padding
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
`;

export const CustomLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  margin-bottom: -16px;
`;

export const CustomRequiredLabel = styled.div`
  display: flex;
  color: #a4262c;
  padding-left: 3px;
`;

export const CustomTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 8px;
  padding-right: 8px;
`;

export const SingleContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  align-items: space-between;
`;

export const DivTextIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const TextStyled = styled(Text)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #323130;
`;

export const dropdownIconClass = mergeStyles({
  fontSize: 20,
  height: 20,
  width: 20,
  color: '#242424',
});

export const checkBoxStyles = {
  text: {
    padding: '0px 0px 0px 4px',
  },
};

export const InitialWizardStepContainer = styled.div`
  display: flex;
  padding-top: 10%;
  padding-bottom: 10%;
  flex-direction: column;
  align-items: center;
`;

export const InitialWizardStepTextStyled = styled(Text)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #323130;
`;

export const InitialWizardStepCommandBar = styled(CommandBar)`
  display: flex;
  padding-top: 20px;
  margin-left: -32px;
`;

export const ReviewRequestContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5%;
`;

export const SubSectionalHeading = styled(Text)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #323130;
  padding-top: 1%;
  padding-bottom: 1%;
`;

export const SectionalDividerDiv = styled.div`
  padding-bottom: 2%;
`;

export const RequestReviewTable = styled.table`
  width: 100%;
  &&& {
    table,
    th {
      border-collapse: collapse;
      width: 35%;
      text-align: left;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      color: #323130;
    }
    td {
      border-collapse: collapse;
      width: 65%;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #323130;
    }
    tr {
      padding-top: 5px;
    }
  }
`;

export const ReviewTable = styled.table`
  width: 100%;
  &&& {
    table {
      padding-bottom: 10px;
    }
    th {
      border-collapse: collapse;
      width: 30%;
      text-align: left;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      color: #323130;
    }
    td {
      border-collapse: collapse;
      width: 65%;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #323130;
    }
    tr {
      padding-top: 5px;
    }
  }
`;

export const TokensTableIndex = styled.th`
  width: 5%;
  text-align: left;
`;

export const PanelHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PanelHeaderTitleText = styled(Text)`
  font-weight: 700;
  font-size: 26px;
  line-height: 32px;
  color: #171717;
  padding-top: 32px;
  padding-bottom: 16px;
  padding-left: 48px;
  padding-right: 48px;
`;

export const PivotStyled = styled(Pivot)`
  display: flex;
  margin-left: 40px;
`;

export const AddExistingObjectContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 2px;
  background: #fafafa; //grey
  border: 1px solid #000000;
`;

export const AddExistingObjectTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
`;

export const AddExistingObjectTitleTextStyled = styled(Text)`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ##171717;
`;

export const SingleRuleContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  align-items: space-between;
`;

export const CheckTextIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const CheckTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const SingleRuleTextStyled = styled(Text)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #323130;
  padding-left: 20px;
`;

export const NavigationTextStyled = styled.a`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #323130;
  padding-left: 20px;
`;

export const LineDivider = styled.div`
  border: 1px solid #e5e5e5;
`;

export const RuleListContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 30px;
  padding-bottom: 30px;
`;